<template>
  <v-layout
    id="product-edit-form"
    justify-center
    wrap
  >
    <v-flex
      xs12
      md8
      lg8
    >
      <h2 v-if="!product">
        {{ $t('modules.productNew') }}
      </h2>
      <h2 v-else>
        {{ $t('modules.productEdit') }}
      </h2>
      <v-card class="pt-7 pl-5 pr-5">
        <v-form>
          <v-layout wrap>
            <helper-cropper
              ref="cropper"
              :aspect-ratio="350 / 350"
              :width="350"
              :height="350"
              @updateAvatar="updateImage"
            />
            <v-flex
              mt-4
              xs12
            >
              <div
                class="image"
                :style="{'border-color': form.bg_color, 'border-width': form.bg_color ? '3px' : '0px'}"
                @click.stop="$refs.image.click()"
              >
                <div
                  v-if="!form.image"
                  class="pt-5 pb-7"
                >
                  <v-icon color="primary">
                    mdi-cloud-upload
                  </v-icon>
                  <p>
                    {{ $t('modules.productUploadImage') }}
                  </p>
                  <p>PNG / JPG</p>
                </div>
                <div style="width:350px;overflow:hidden;">
                  <img
                    v-if="form.image"
                    :src="form.image"
                    width="350"
                  >
                </div>
                <input
                  ref="image"
                  type="file"
                  style="display: none"
                  accept="image/*"
                  @change="setImage"
                >
              </div>
              <div class="text-center mt-2">
                <!-- <v-menu
                  offset-y
                  right
                  bottom
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined 
                      small
                      text
                      v-on="on"
                    >
                      <v-icon>
                        mdi-border-all-variant
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-color-picker
                    v-model="pickedColor"
                    elevation="1"
                    @update:color="form.bg_color = pickedColor"
                  />
                </v-menu> -->
                <!-- <v-btn
                  v-if="form.bg_color"
                  class="ml-2"
                  outlined 
                  small
                  text
                  @click="form.bg_color = ''"
                >
                  <v-icon>
                    mdi-select-off
                  </v-icon>
                </v-btn> -->
                <v-btn
                  v-if="form.image"
                  class="ml-2"
                  outlined
                  small 
                  text
                  @click="form.image = ''; $refs.image.value = '';"
                >
                  <v-icon>
                    mdi-bucket-outline
                  </v-icon>
                </v-btn>
              </div>
            </v-flex>
            <v-flex
              xs12
              md7
            >
              <v-text-field
                v-model.trim="form.name"
                :counter="50"
                :error-messages="NameErrors"
                :label="$t('modules.productName')+ '*'"
                required
                @input="$v.form.name.$touch()"
                @blur="$v.form.name.$touch()"
              />
            </v-flex>
            <v-flex
              xs10
              md4
            >
              <v-select
                v-model.trim="selectedCategories"
                :items="categories"
                :item-text="'name'"
                :item-value="'id'"
                :error-messages="CategoriesErrors"
                :label="$t('modules.productCategory')+'*'"
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 1"
                    class="info"
                    small
                  >
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                  >
                    <small>+ {{ $t('modules.productMore') }}</small>
                  </span>
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs2
              md1
              pt-7
            >
              <v-btn
                small
                text
                outlined
                @click="editCategoriesDialog = true"
              >
                <v-icon>
                  mdi-plus-circle-outline
                </v-icon>
              </v-btn>
            </v-flex>
            <v-flex
              xs12
            >
              <v-select
                v-model.trim="form.status"
                :items="statuses"
                :item-text="'text'"
                :item-value="'id'"
                :error-messages="StatusErrors"
                :label="$t('modules.productStatus')+'*'"
              />
            </v-flex>
            <v-flex
              lg12
              mt-3
            >
              <b>{{ $t("modules.productPricing") }}</b>
            </v-flex>
            <v-flex
              xs6
            >
              <v-select
                v-model.trim="form.currency"
                :items="moduleData.public_config.currency"
                :error-messages="CurrencyErrors"
                :label="$t('modules.productCurrency')+'*'"
                required
                @change="$v.form.currency.$touch()"
              />
            </v-flex>
            <v-flex
              xs6
            >
              <v-text-field
                v-model.trim.number="form.overdue_days"
                :error-messages="OverdueDaysErrors"
                :label="$t('modules.productOverdueDays')+ '*'"
                required
                @input="$v.form.overdue_days.$touch()"
                @blur="$v.form.overdue_days.$touch()"
              >
                <template
                  v-slot:append
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ $t('modules.productOverdueHint') }}
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              v-for="(item, i) in pricing"
              :key="i"
              xs6
              md4
            >
              <v-text-field
                v-model.trim.number="form[item]"
                :error-messages="pricing_errors[item]"
                :label="$t('modules.product_'+ item)"
                required
                :suffix="form.currency"
                @input="validatePricing(item)"
                @blur="validatePricing(item)"
                @keypress="onlyForCurrency($event, form[item])"
              >
                <template
                  v-if="item == 'last_price'"
                  v-slot:append
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ $t('modules.productLastPriceHint') }}
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              xs12
              mt-3
            >
              <b>{{ $t("modules.upgradableProducts") }}</b>
            </v-flex>
            <v-flex
              xs12
            >
              <upgradable-products 
                ref="upgradableProducts"
                :products="products"
                :product-id="product ? product.id : null"
                :edit-list="form.allowed_upgrades"
                @saveProducts="saveUpgradableProducts"
              />
            </v-flex>
            <v-flex
              xs12
              mt-3
            >
              <b>{{ $t("modules.productDescription") }}</b>
            </v-flex>
            <v-flex>
              <vue-editor
                id="editor"
                v-model="form.description"
                :editor-toolbar="customToolbar"
                :editor-options="editorSettings"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md12
            >
              <v-btn
                fab
                outlined
                small
                text
                @click="$emit('closeEditMode', false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                color="primary"
                style="float:right"
                :disabled="loading"
                :loading="loading"
                @click="save()"
              >
                {{ $t('globals.saveButton') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-flex>
    <edit-categories-dialog
      v-if="editCategoriesDialog"
      :show-dialog="editCategoriesDialog"
      @closeEditCategoriesDialog="closeEditCategoriesDialog"
    />
  </v-layout>
</template>

<script>
import PRODUCT_CREATE_MUTATION from "@/graphql/mutations/modules/ProductCreate.gql"; 
import PRODUCT_UPDATE_MUTATION from "@/graphql/mutations/modules/ProductUpdate.gql";
import EditCategoriesDialog from "./partial/EditCategoriesDialog.vue";
import UpgradableProducts from "./partial/UpgradableProducts.vue";

import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

export default {
  name: "ModuleProductEditForm",
  components: {
    VueEditor,
    UpgradableProducts,
    EditCategoriesDialog,
  },
  mixins: [validationMixin],
  props: {
    product: {
      type: Object,
      default: null
    },
    products: {
      type: Array,
      default: null
    },
    categories: {
      type: Array,
      default: null
    },
    whitelabelUuid: {
      type: String,
      default: null
    },
    moduleData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      pickedColor: "",
      editCategoriesDialog: false,
      statuses: [
        {id: "active", text: this.$t('modules.productStatusActive')},
        {id: "inactive", text: this.$t('modules.productStatusInactive')}
      ],
      selectedCategories: [],
      pricing_errors: [],
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': []}, 'link', 'image'],

        ['clean']
      ],
      editorSettings: {
        modules: {
          imageResize: {
            displaySize: true,
            imageDrop: true
          }
        }
      },
      pricing: [
        "price_onetime",
        "price_monthly",
        "price_quartally",
        "price_semiannually",
        "price_annually",
        "last_price"
      ],
      form: {}
    }
  },
  computed: {
    rules() {
      const priceRules = []
      this.pricing.map(item => {
        priceRules[item] = { required }
      })
      return {
        name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(50),
        },
        currency: {
         required,
        },
        status: {
         required,
        },
        categories: {
          required,
        },
        overdue_days: {
          required,
        },
        ...priceRules
      }
    },
    NameErrors(value) {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.name.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.name.$params.minLength.min}));
      !this.$v.form.name.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.name.$params.maxLength.max}));
      return errors;
    },
    StatusErrors(value) {
      const errors = [];
      if (!this.$v.form.status.$dirty) return errors;
      !this.$v.form.status.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    CategoriesErrors(value) {
      const errors = [];
      if (!this.$v.form.categories.$dirty) return errors;
      !this.$v.form.categories.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    CurrencyErrors(value) {
      const errors = [];
      if (!this.$v.form.currency.$dirty) return errors;
      !this.$v.form.currency.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    OverdueDaysErrors(value) {
      const errors = [];
      if (!this.$v.form.overdue_days.$dirty) return errors;
      !this.$v.form.overdue_days.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
  },
  watch: {
    selectedCategories: {
      handler(value) {
        this.form.categories = []
        this.selectedCategories.map((id) => {
          this.form.categories.push({category_id: id})
        })
          this.$v.form.categories.$touch()
        },
      deep: true
    }
  },
  mounted() {
    const form = JSON.parse(JSON.stringify(this.product))
    if (form) {
      this.form = form
      if(!this.form.allowed_upgrades) {
        this.form.allowed_upgrades = []
      }
      form.categories.map(item => {
        this.selectedCategories.push(item.category.id)
      })
    } else {
      this.form = {
        name: "",
        description: "",
        bg_color: "",
        image: "",
        status: "",
        price_onetime: 0,
        price_monthly: 0,
        price_quartally: 0,
        price_semiannually: 0,
        price_annually: 0,
        last_price: 0,
        overdue_days: 0,
        currency: "",
        categories: [],
        allowed_upgrades: []
      }
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {
    validatePricing(field) {
      this.$v.form[field].$touch()
      this.$v.form[field].$touch()
      const errors = [];

      if (!this.$v.form[field].$dirty) {
        return
      }

      !this.$v.form[field].required &&
        errors.push(this.$t("projects.reqField"));

      this.pricing_errors[field] = errors
      this.$emit("onUpdate", this.form);
    },
    closeEditCategoriesDialog(val) {
      this.editCategoriesDialog = false
      if (val) {
        this.$parent.queries.moduleProductsCategories.refetch()
      }
    },
    setImage(e) {
      if (!this.$refs.cropper.setImage(e)) {
        this.$refs.image.value = "";
      }
    },
    updateImage(image) {
      this.form.image = image;
    },
    saveUpgradableProducts(products) {
      this.form.allowed_upgrades = products;
    },
    save() {
      this.$refs.upgradableProducts.$v.$touch();
      this.$v.$touch();
      if (this.$v.$invalid || this.$refs.upgradableProducts.$v.$invalid) {
        return
      }
      this.$refs.upgradableProducts.save();
      this.loading = true;
      this.form.whitelabel_uuid = this.whitelabelUuid
      this.$apollo
        .mutate({
          mutation: !this.product ? PRODUCT_CREATE_MUTATION : PRODUCT_UPDATE_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.$emit('closeEditMode', true)
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
}
</script>

<style lang="scss">
#editor {
  height: 400px;
}
#product-edit-form {
  .image {
    width: 306px;
    margin: 0 auto;
    border: 3px solid;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    i {
      margin: 5px 0 0px;
      font-size: 26px;
    }
    p {
      margin: 7px 0 0!important;
      &:first-of-type {
        font-weight: 700;
      }
      line-height: 0.85rem;
    }
    small {
      font-size: 11px;
    }
    &.no-border {
      border: 0 !important;
    }
  }
}
</style>
